import React, { useState } from "react";
import {
  Card,
  CardBody,
  Label,
  FormGroup,
  Row,
  Input,
  Container,
  CardHeader,
  CardFooter,
  Button,
  Form, FormFeedback
} from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import axios from 'axios';
import SimpleHeader from "components/Headers/SimpleHeader.js";

export default function CreateAcquirer() {
  const token = localStorage.token;
  const [acquirerName, setAcquirerName] = useState("");
  const [acquirerNameError, setAcquirerNameError] = useState(null);
  const [acquirerCode, setAcquirerCode] = useState("");
  const [acquirerCodeError, setAcquirerCodeError] = useState(null);
  let history = useHistory();
  const [isLoading, setLoading] = useState(false);

  const [acquirerErrorMessage, setAcquirerErrorMessage] = useState(null);
  const [acquirerCodeErrorMessage, setAcquirerCodeErrorMessage] = useState(null);

  const validateForm = () => {
    let error = false;
    if (acquirerName === "") {
      setAcquirerNameError("invalid");
      error = true;
    }
    if (acquirerCode === "") {
      setAcquirerCodeError("invalid");
      error = true;
    }
    return error;
  };

  function CreateData() {
    setLoading(true);
    let data = {
      acquirer_name: acquirerName,
      acquirer_code: acquirerCode
    }
    axios.post(`${process.env.REACT_APP_API_BASE_URL}/acquirer/save`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
      .then(function (response) {
        if (response.data.errors) {
          showErrors(response.data.errors);
          return;
        }
        history.push("/admin/acquirer");
      })
      .then(json => {
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  const showErrors = (error) => {
    let errors = false;
    if (error.acquirer_name) {
      setAcquirerNameError("invalid");
      setAcquirerErrorMessage(error.acquirer_name);
      errors = true;
    }
    if (error.acquirer_code) {
      setAcquirerCodeError("invalid");
      setAcquirerCodeErrorMessage(error.acquirer_code);
      errors = true;
    }
    return errors;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) {
      CreateData();
    }
  }
  return (
    <>
      <SimpleHeader name="Daftar Acquirer" parentName="Admin" />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <Card>
              <CardBody>
                <Form onSubmit={handleSubmit} >
                  <CardHeader>
                    <h3>Daftar Acquirer</h3>
                  </CardHeader>
                  <CardBody>
                    <FormGroup>
                      <Label
                        className="form-control-label"
                        htmlFor="serial_number"
                      >
                        Acquirer
                                            </Label>
                      <Input
                        type="text"
                        name="acquirer_name"
                        placeholder="Masukan Acquirer Name"
                        value={acquirerName}
                        invalid={acquirerNameError === "invalid"}
                        onChange={(e) => {
                          setAcquirerName(e.target.value);
                          if (e.target.value !== "") {
                            setAcquirerNameError("");
                          }
                        }}
                      />
                      <FormFeedback>
                        {
                          acquirerName === "" ? "Acquirer Name tidak boleh kosong" : acquirerErrorMessage
                        }
                      </FormFeedback>
                    </FormGroup>
                    <FormGroup>
                      <Label
                        className="form-control-label"
                        htmlFor="exampleFormControlInput1"
                      >
                        Bank Code
                                            </Label>
                      <Input
                        type="text"
                        name="acquirer_code"
                        placeholder="Masukan Bank Code"
                        value={acquirerCode}
                        invalid={acquirerCodeError === "invalid"}
                        onChange={(e) => {
                          setAcquirerCode(e.target.value);
                          if (e.target.value !== "") {
                            setAcquirerCodeError("");
                          }
                        }}
                      />
                      <FormFeedback>
                        {
                          acquirerCode === "" ? "Bank Code tidak boleh kosong" : acquirerCodeErrorMessage
                        }
                      </FormFeedback>
                    </FormGroup>
                  </CardBody>
                  <CardFooter>
                    {!isLoading && (<Button color="primary" type="submit">
                      Simpan
                    </Button>)}
                    {isLoading && (<Button color="primary" disabled>
                      <i className="fas fa-spinner fa-spin"></i>{""}
                      loading...
                    </Button>)}
                    <Link class="btn btn-info" to="/admin/acquirer">
                      Cancel
                                        </Link>
                  </CardFooter>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
}
